/**
 * <ldy-fila> — carosello unico di LeiDry (recensioni, frasi, card «come si porta», «Aggiungi anche» del carrello).
 * Struttura:
 *   <ldy-fila class="ldy-fila">
 *     <div class="ldy-fila__binario" data-binario> …elementi… </div>
 *     <button class="ldy-freccia" data-dir="-1">…</button> <button class="ldy-freccia" data-dir="1">…</button>  (facoltative)
 *     <div class="ldy-punti" data-punti></div>  (facoltativo: i puntini si creano da soli, uno per elemento)
 *   </ldy-fila>
 * Frecce, puntini, trascinamento col mouse (sul telefono scorre il dito, con lo scatto del CSS).
 */
class LdyFila extends HTMLElement {
  connectedCallback() {
    this.binario = this.querySelector('[data-binario]');
    if (!this.binario || this.pronto) return;
    this.pronto = true;
    this.frecce = [...this.querySelectorAll('[data-dir]')];
    this.punti = this.querySelector('[data-punti]');
    this.frecce.forEach((b) => b.addEventListener('click', () => this.vai(Number(b.dataset.dir))));
    if (this.punti) this.creaPunti();
    this.aggiorna = this.aggiorna.bind(this);
    this.binario.addEventListener('scroll', () => requestAnimationFrame(this.aggiorna), { passive: true });
    this.trascina();
    this.aggiorna();
  }

  get elementi() {
    return [...this.binario.children];
  }

  passo() {
    const [a, b] = this.elementi;
    if (!a) return this.binario.clientWidth;
    return b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
  }

  vai(dir) {
    this.binario.scrollBy({ left: dir * this.passo(), behavior: 'smooth' });
  }

  creaPunti() {
    this.punti.textContent = '';
    this.elementi.forEach((el, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `${i + 1} di ${this.elementi.length}`);
      b.addEventListener('click', () => this.binario.scrollTo({ left: el.offsetLeft - this.elementi[0].offsetLeft, behavior: 'smooth' }));
      this.punti.append(b);
    });
  }

  aggiorna() {
    const { scrollLeft, scrollWidth, clientWidth } = this.binario;
    const fine = scrollWidth - clientWidth - 2;
    this.frecce.forEach((b) => {
      b.disabled = Number(b.dataset.dir) < 0 ? scrollLeft <= 2 : scrollLeft >= fine;
    });
    if (this.punti) {
      const i = Math.round(scrollLeft / Math.max(1, this.passo()));
      [...this.punti.children].forEach((p, j) => p.setAttribute('aria-current', String(j === Math.min(i, this.punti.children.length - 1))));
    }
  }

  trascina() {
    let x0 = 0;
    let s0 = 0;
    let giu = false;
    let mosso = false;
    this.binario.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      giu = true;
      mosso = false;
      x0 = e.clientX;
      s0 = this.binario.scrollLeft;
    });
    window.addEventListener('pointermove', (e) => {
      if (!giu) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 4) {
        mosso = true;
        this.binario.classList.add('is-trascina');
        this.binario.scrollLeft = s0 - dx;
      }
    });
    window.addEventListener('pointerup', () => {
      if (!giu) return;
      giu = false;
      this.binario.classList.remove('is-trascina');
    });
    this.binario.addEventListener(
      'click',
      (e) => {
        if (mosso) {
          e.preventDefault();
          e.stopPropagation();
          mosso = false;
        }
      },
      true
    );
  }
}

if (!customElements.get('ldy-fila')) customElements.define('ldy-fila', LdyFila);
